import "./Prologo.css"
const Prologo = () =>{
return(
<section className="Prologo">
    <h2>El Prologo</h2>
    <p>En una tarde calurosa de principios de setiembre me encontré por primera vez con el
hombre ilustrado. Yo caminaba por una carretera asfaltada, recorriendo la última etapa de
una excursión de quince días por el Estado de Wisconsin. Al atardecer me detuve, comí
un poco de carne de cerdo, unas habas y un bizcocho. Me preparaba a descansar y leer
cuando el hombre ilustrado apareció sobre la colina. Su figura se recortó brevemente
contra el cielo.</p>
<p>
Yo no sabía entonces que era ilustrado; sólo vi que era alto, que alguna vez había sido
esbelto, y que ahora, por alguna razón, comenzaba a engordar. Recuerdo que tenía los
brazos largos y las manos anchas, y un rostro infantil en lo alto de un cuerpo macizo.
Me hablo antes de verme, como si hubiese adivinado mi presencia.
</p>
<p>
-Señor, ¿sabe usted dónde podría encontrar trabajo?
</p>
<p>
-Temo que no -le respondí.
</p>
<p>
-Cuarenta años y nunca he tenido un trabajo duradero -me dijo.</p>
<p>
Aunque hacía mucho calor, el hombre ilustrado llevaba una camisa de lana, cerrada
hasta el cuello. Los puños de las mangas le ocultaban las anchas muñecas. La
transpiración le corría por la cara. Y sin embargo no se abría la camisa.</p>
<p>-Bien -me dijo al fin-, este lugar es tan bueno como cualquiera para pasar la noche.</p>
<p>¿No lo molesto?</p>
<p>-Si usted quiere, me sobra un poco de comida -le invité.</p>
<p>Se sentó pesadamente y lanzó un gruñido.</p>
<p>-Se arrepentir de haberme invitado -me dijo-. Todos se arrepienten. Por eso no paro en
ningún sitio.</p>
<p>Aquí estamos, a principios de setiembre, en lo mejor de la temporada de las ferias.
Tendría que estar ganando montones de dinero en el parque de diversiones de cualquier
pueblo, y aquí me tiene, sin ninguna perspectiva.</p>
<p>El hombre ilustrado se sacó un enorme zapato y lo examinó con atención.</p>
<p>-Comúnmente conservo mi empleo diez días. Luego algo ocurre, y me despiden. Hoy
ningún hombre, de ninguna feria del país se atrevería a tocarme, ni con una pértiga de
tres metros.</p>
<p>-¿Qué le pasa? -le pregunté.</p>
<p>El hombre me respondió desabotonándose lentamente el cuello apretado. Cerró los
ojos, y con movimientos muy lentos se abrió la camisa. Luego, con la punta de los dedos,
se tocó la piel.</p>
<p>-Es curioso -dijo con los ojos todavía cerrados-. No se las siente, pero están ahí. No
dejo de pensar que algún día miraré y ya no estarán. Camino al sol durante horas, en los
días más calurosos, cocinándome y esperando que el sudor las borre, que el sol las
queme; pero llega la noche, y están todavía ahí.</p>
<p>El hombre ilustrado volvió hacia mí la cabeza, mostrándome el pecho.</p>
<p>-¿Están todavía ahí? -me preguntó.</p>
<p>Durante unos instantes no respiré.</p>
<p>-Si -dije-, están todavía ahí.</p>
<p>Las ilustraciones.</p>
<p>-Me cierro la camisa a causa de los niños -dijo el hombre abriendo los ojos-. Me siguen
por el campo. Todo el mundo quiere ver las imágenes, y sin embargo nadie quiere verlas.
El hombre se sacó la camisa y la apretó entre las manos. Tenía el pecho cubierto de
ilustraciones, desde el anillo azul, tatuado alrededor del cuello, hasta la línea de la cintura.
-Y así en todas partes -me dijo adivinándome el pensamiento-. Estoy totalmente
tatuado. Mire.</p>
<p>
Abrió la mano. En la mano se veía una rosa recién cortada, con unas gotas de agua
cristalina entre los suaves pétalos rojizos. Extendí la mano para tocarla, pero era sólo una
ilustración.
</p>
<p>
En cuanto al resto, no sé cómo pude quedarme quieto y mirar. El hombre ilustrado era
una acumulación de cohetes, y fuentes, y personas, dibujados y coloreados con tanta
minuciosidad que uno creía oír las voces y los murmullos apagados de las multitudes que
habitaban su cuerpo. Cuando la carne se estremecía, las manitas rosadas gesticulaban,
los labios menudos se movían, en los ojitos verdes y dorados se cerraban los párpados.
Había prados amarillos y ríos azules, y montañas y estrellas y soles y planetas,
extendidos por el pecho del hombre ilustrado como una vía láctea. Las gentes se dividían
en veinte o más grupos, instalados en los brazos, los hombros, las espaldas, los
costados, las muñecas y la parte alta del vientre. Se los veía en bosques de vello,
escondidos en una constelación de pecas, o hundidos en las cavernas de las axilas, con
ojos resplandecientes como diamantes. Cada grupo parecía dedicado a su propia
actividad; cada grupo era toda una galería de retratos.
</p>
<p>
-¡Oh! ¡Son hermosas! -exclamé.
</p>
<p>
¿Cómo podría describir las ilustraciones? Si en lo mejor de su carrera el Greco hubiese
pintado miniaturas, no mayores que tu mano, infinitamente detalladas, con sus colores
sulfurosos y sus deformaciones, quizá hubiera utilizado para su arte el cuerpo de este
hombre. Los colores ardían en tres dimensiones. Eran como ventanas abiertas a mundos
luminosos. Aquí, reunidas en un muro, estaban las más hermosas escenas del universo.
El hombre ilustrado era un museo ambulante. No era ésta la obra de esos ordinarios
tatuadores de feria que trabajan con tres colores y un aliento que huele a alcohol. Era el
trabajo de un genio; una obra vibrante, clara y hermosa. 
</p>
<p>
-Ah, si -dijo el hombre ilustrado-, mis ilustraciones. Me siento tan orgulloso de ellas que
me gustaría destruirlas. He probado con papel de lija, con ácidos, con un cuchillo...
</p>
<p>
El sol se ponía. La luna se levantaba ya por el este.
</p>
<p>
-Pues estas ilustraciones -afirmó el hombre-, predicen el futuro.
</p>
<p>
No dije nada.  
</p>
<p>
-Todo está bien a la luz del sol -continuó-. Puedo emplearme entonces en una feria.
Pero de noche... Las pinturas se mueven. Las imágenes cambian.
</p>
<p>
Creo que sonreí
</p>
<p>
-¿Desde cuándo está usted ilustrado?
</p>
<p>
-Desde el año 1900. Yo tenía entonces veinte años y trabajaba en un parque de
diversiones. Me rompí una pierna. No podía moverme. Tenía que hacer algo para no perder el empleo, y entonces decidí tatuarme.
</p>
<p>
-Pero ¿quién lo tatuó? ¿Qué pasó con el artista?
</p>
<p>
-La mujer volvió al futuro -dijo el hombre-. Así es. Vivía en una casita en el interior de
Wisconsin, no muy lejos de aquí. Una vieja bruja que en un momento parecía tener cien
años y poco después no más de veinte. Me dijo que ella podía viajar por el tiempo. Yo me
reí. Pero ahora sé que decía la verdad.   
</p>
<p>
-¿Cómo la conoció?
</p>
<p>
El hombre ilustrado me lo dijo. Había visto el letrero al lado del camino.
¡ILUSTRACIONES EN LA PIEL! ¡Ilustraciones, y no tatuajes! ¡Ilustraciones artísticas! Y
allí había estado, toda la noche, mientras las mágicas agujas lo mordían y picaban como
avispas y abejas delicadas. A la mañana parecía un hombre que hubiese caído bajo una
prensa multicolor: tenía el cuerpo brillante y cubierto de figuras.
</p>
<p>
-He buscado a esa bruja todos los veranos, durante casi medio siglo -dijo el hombre
extendiendo los brazos-. Cuando la encuentre, la mataré.
</p>
<p>
El sol se había ido. Brillaban ya las primeras estrellas y la luna iluminaba los pastos y
las espigas. Las imágenes del hombre ilustrado resplandecían en la sombra como
carbones encendidos, como esmeraldas y rubíes con los colores de Rouault y de Picasso,
y los cuerpos enjutos y alargados del Greco.
</p>
<p>
-Cuando las imágenes empiezan a moverse, me despiden. Ocurren cosas terribles en
mis ilustraciones. Cada una es un cuento. Si usted las mira atentamente unos pocos
minutos, le contarán una historia. Si las mira tres horas, las narraciones serán treinta o
cuarenta, y usted oirá voces, y pensamientos. Todo está aquí, en mi piel; no hay más que
mirar. Pero sobre todo, hay cierto lugar de mi espalda... -El hombre ilustrado se volvió-.
¿Ve? Sobre mi omóplato derecho no hay ningún dibujo. Sólo una mancha de color. 
</p>
<p>
-Si.
</p>
<p>
-Cuando he estado con alguien un rato, ese omóplato se cubre de sombras, y se
convierte en un dibujo. Si estoy con una mujer, al cabo de una hora su rostro aparece ahí,
en mi espalda, y ella ve toda su vida... cómo vivirá y cómo morirá, qué parecerá cuando
tenga sesenta anos. Y si me encuentro con un hombre, una hora después su retrato
aparece también en mi espalda. Y el hombre se ve a si mismo cayendo en un precipicio, o
aplastado por un tren... Entonces me despiden.
</p>
<p>
El hombre hablaba y al mismo tiempo movía las manos sobre las ilustraciones, como
para ajustar los marcos y sacarles el polvo, con los ademanes de un conocedor, de un
aficionado al arte. Al fin se tendió de espaldas, a la luz de la luna. Era una noche calurosa,
serena y sofocante. Nos habíamos sacado la camisa.
</p>
<p>
-¿Y nunca encontró a la vieja?
</p>
<p>
-Nunca.
</p>
<p>
-¿Y cree usted que venía del futuro?
</p>
<p>
-¿Cómo, si no, podría conocer estas historias que me pintó sobre la piel?
</p>
<p>
El hombre, fatigado, cerro los ojos.
</p>
<p>
-A veces, de noche -dijo débilmente-, siento las figuras. como hormigas sobre la piel.
Sé lo que pasa entonces y lo que tiene que pasar. Yo nunca las miro. Trato de olvidarme.
No debemos mirarlas. No las mire usted tampoco, se lo advierto. Vuélvame la espalda
cuando se vaya a dormir.
</p>
<p>
Yo estaba acostado no muy lejos. El hombre no tenía, aparentemente, un carácter
violento, y las ilustraciones eran tan hermosas... Yo me hubiese ido lejos de toda esa
charla. Pero las ilustraciones... Dejé que los ojos se me llenaran de imágenes. Con esos
cuadros sobre el cuerpo, cualquiera podía perder la cabeza.
</p>
<p>
La noche era serena. Yo podía oír la respiración del hombre ilustrado, bañado por la
luna. Los grillos cantaban dulcemente en las hondonadas lejanas. Me puse de costado
para ver mejor las ilustraciones. Pasó, quizá, una media hora. Yo no sabía si el hombre
ilustrado se había dormido, pero de pronto lo oí respirar:
</p>
<p>
-Se mueven, ¿no es cierto?
</p>
<p>
Esperé un minuto. Y luego dije:
</p>
<p>
-Sí. 
</p>
<p>
Las imágenes se movían, Una por vez, uno o dos minutos. Allí, a la luz de la luna, con
el menudo tintineo de los pensamientos y las voces distantes como voces del mar, se
desarrollaron los dramas. No sé si esos dramas duraron una hora o dos. Sólo sé que me
quedé allí, inmóvil, fascinado, mientras las estrellas giraban en el cielo.
</p>
<p>
Dieciocho ilustraciones, dieciocho cuentos. los conté uno a uno  
</p>
<p>
Primero, mis ojos se posaron en una escena, una casa grande con dos personas. Vi
unos buitres que volaban en un cielo rosado y ardiente. Vi leones amarillos, y oí voces.
</p>
<p>
La primera ilustración tembló y se animó.
</p>
</section>
)
}
export default Prologo